import clsx from "clsx";
import React, { useCallback, useState } from "react";
import { Promotion } from "web/react/components/promotion/promotion";
import { Button } from "web/react/emo/button";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import { FeedPromotionsSerializer } from "web/types/serializers";
import * as styles from "./promotion-info.css";

export interface PromotionInfoProps {
    promotions: FeedPromotionsSerializer;
}

const MAX_EXPIRED_PROMO_LENGTH = 10;
const MIN_EXPIRED_PROMO_LENGTH = 3;

export function PromotionInfo({ promotions }: PromotionInfoProps): JSX.Element {
    const [showMore, setShowMore] = useState(false);

    const handleShowMore = useCallback(() => setShowMore(true), []);

    return (
        <View>
            <View className={styles.promoContainer}>
                <Text as="p" textStyle="body-bold">
                    {gettext("promotion_message.currently_active_promotions")}
                </Text>
                {promotions.active_promotions.map((promotion, idx) => (
                    <div key={idx} className={styles.promoCalloutContainer}>
                        <Promotion
                            message={promotion.description}
                            promoCode={promotion.discount_code}
                            isActive={true}
                            pageType="storefront"
                            expirationDateTimestamp={promotion.expiration_date}
                        />
                    </div>
                ))}
            </View>

            <View marginTop="sm" className={styles.promoContainer}>
                <Text as="p" textStyle="body-bold">
                    {gettext("promotion_message.previously_expired_promotions_number", {
                        number: Math.min(promotions.expired_promotions.length, 10),
                    })}
                </Text>

                <View
                    className={clsx(styles.promoContainer, {
                        [styles.expiredPromotionsScroll]: showMore,
                    })}
                >
                    {promotions.expired_promotions
                        .slice(
                            0,
                            showMore
                                ? Math.min(
                                      promotions.expired_promotions.length,
                                      MAX_EXPIRED_PROMO_LENGTH
                                  )
                                : MIN_EXPIRED_PROMO_LENGTH
                        )
                        .map((promotion, idx) => (
                            <div key={idx} className={styles.promoCalloutContainer}>
                                <Promotion
                                    message={promotion.description}
                                    promoCode={promotion.discount_code}
                                    isActive={false}
                                    pageType="storefront"
                                    expirationDateTimestamp={promotion.expiration_date}
                                />
                            </div>
                        ))}

                    {!showMore &&
                        promotions.expired_promotions.length > MIN_EXPIRED_PROMO_LENGTH && (
                            <Button
                                title={gettext("promotion.button.load_more")}
                                onClick={handleShowMore}
                                className={styles.showMoreButton}
                                variant="secondary"
                            />
                        )}
                </View>
            </View>
        </View>
    );
}
